/**
 * Traverse Form.io component trees (panels, nested `components`, column layouts).
 * Shared by submissions grid/schema extractors and PDF/CSV label collection.
 */

export const visitNestedComponents = (node, visit) => {
  if (Array.isArray(node?.components)) {
    node.components.forEach(visit);
  }
};

export const visitNestedColumns = (node, visit) => {
  if (!Array.isArray(node?.columns)) {
    return;
  }
  node.columns.forEach((col) => visitNestedComponents(col, visit));
};

/**
 * Resolve a cell/field formatter kind by running ordered checks.
 * @param {readonly [string, (...args: unknown[]) => boolean][]} checks
 * @param {...unknown} args forwarded to each test
 * @returns {string}
 */
export const resolveFieldKindFromChecks = (checks, ...args) => {
  for (const [kind, test] of checks) {
    if (test(...args)) {
      return kind;
    }
  }
  return 'default';
};
